// extracted by mini-css-extract-plugin
export default {"element":"element_MaxLength-module_1OWLo","count":"count_MaxLength-module_3d6W9","warning":"warning_MaxLength-module_15gi5"};